<template>
    <div>
        <div class="emboss_deboss_color_custom_box">
            <div class="emboss_shadow_box">
                <form action="#">
                    <div
                        class="form__group d-flex align-items-center justify-content-between mt_20"
                    >
                        <div class="form__radio-group">
                            <!-- eslint-disable -->
                            <input
                                type="radio"
                                name="shadow"
                                id="Top"
                                class="form__radio-input"
                                v-model="directionShadow"
                                v-bind:value="'Top'"
                                v-on:change="setValue"
                            />
                            <!-- eslint-enable -->
                            <label class="form__label-radio" for="Top">
                                <span class="form__radio-button"></span> Top
                            </label>
                        </div>

                        <div class="form__radio-group">
                            <!-- eslint-disable -->
                            <input
                                type="radio"
                                name="shadow"
                                id="Right"
                                class="form__radio-input"
                                v-model="directionShadow"
                                v-bind:value="'Right'"
                                v-on:change="setValue"
                            />
                            <!-- eslint-enable -->
                            <label class="form__label-radio" for="Right">
                                <span class="form__radio-button"></span> Right
                            </label>
                        </div>

                        <div class="form__radio-group">
                            <!-- eslint-disable -->
                            <input
                                type="radio"
                                name="shadow"
                                id="Bottom"
                                class="form__radio-input"
                                v-model="directionShadow"
                                v-bind:value="'Bottom'"
                                v-on:change="setValue"
                            />
                            <!-- eslint-enable -->
                            <label class="form__label-radio" for="Bottom">
                                <span class="form__radio-button"></span> Bottom
                            </label>
                        </div>

                        <div class="form__radio-group">
                            <!-- eslint-disable -->
                            <input
                                type="radio"
                                name="shadow"
                                id="Left"
                                class="form__radio-input"
                                v-model="directionShadow"
                                v-bind:value="'Left'"
                                v-on:change="setValue"
                            />
                            <!-- eslint-enable -->
                            <label class="form__label-radio" for="Left">
                                <span class="form__radio-button"></span> Left
                            </label>
                        </div>
                    </div>
                </form>
            </div>

            <div class="d-flex align-items-center mt_10 shadow_width">
                <div class="form-group mr_20">
                    <div class="range h-auto">
                        <!-- eslint-disable -->
                        <input
                            v-model="value"
                            v-on:change="setValue"
                            id="embossValue"
                            type="range"
                            min="0"
                            max="100"
                            class="input_type_rang_custom"
                        />
                        <!-- eslint-enable -->
                    </div>
                    <label>Shadow</label><span class="highlight"></span>
                </div>
                <div
                    :class="
                        (mTop === 0 ? 'setwidth_top_margin ' : ' ') +
                        'addtext_color font-size_add rot_value'
                    "
                >
                    <div class="form-group">
                        <!-- eslint-disable -->
                        <input
                            v-on:change="setValue"
                            type="number"
                            v-model="value"
                            id="embossValueInput"
                            required="required"
                            placeholder="0"
                            min="0"
                            max="100"
                            class="range_slider_input span2 form-control bg-whit"
                        />
                        <!-- eslint-enable -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EmbossBox",
    props: ["value", "directionShadow", "mTop"],
    data: () => {
        return {};
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", Number(this.value), this.directionShadow);
            console.log(e);
        }
    }
};
</script>

<style></style>
